<template>
<span
  :class="$c('span')"
  :ui="realUi"
>
  <slot/>
</span>
</template>

<script>
import 'veui/locale/zh-Hans/common.js'
import 'veui/locale/en-US/common.js'

import prefix from '../mixins/prefix'
import ui from '../mixins/ui'

export default {
  name: 'veui-span',
  mixins: [prefix, ui]
}
</script>
